var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLatticeLogoNestColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "143px",
    height: "80px",
    viewBox: "0 0 143 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "slide",
    transform: "translate(-136.000000, -423.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-nest-color",
    transform: "translate(136.000000, 423.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nest"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.60536,59.1202162 L14.74956,39.2445405 C11.37564,35.8672432 5.90544,35.8672432 2.53044,39.2445405 C-0.84348,42.6218378 -0.84348,48.0975135 2.53044,51.4758919 L28.4958,77.4672432 C31.86972,80.8445405 37.341,80.8445405 40.71492,77.4672432 L65.15424,53.0023784 L52.9362,40.771027 L34.60536,59.1202162 Z",
    id: "bg",
    fill: "#1AAD94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.447092,20.9002162 L71.265852,59.1196757 L33.080292,20.8958919 C29.705292,17.5175135 24.235092,17.5175135 20.861172,20.8958919 C17.487252,24.2731892 17.487252,29.7488649 20.861172,33.1272432 L65.156292,77.4667027 C68.530212,80.844 74.000412,80.844 77.375412,77.4667027 L121.666212,33.1315676 C125.040132,29.7531892 125.040132,24.2775135 121.666212,20.9002162 C118.291212,17.5229189 112.821012,17.5229189 109.447092,20.9002162",
    id: "bg",
    fill: "#F2AE20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.995864,51.4796757 L114.034824,77.4667027 C110.660904,80.844 105.190704,80.844 101.816784,77.4667027 L39.190824,14.7780541 C35.816904,11.4007568 35.816904,5.92508108 39.190824,2.54778378 C42.565824,-0.830594595 48.036024,-0.830594595 51.409944,2.54778378 L107.925264,59.1196757 L127.776744,39.2483243 C131.151744,35.871027 136.621944,35.871027 139.995864,39.2483243 C143.369784,42.6267027 143.369784,48.1023784 139.995864,51.4796757",
    id: "bg",
    fill: "#E76450"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.335912,2.55189189 C99.961992,-0.825405405 94.491792,-0.825405405 91.116792,2.55189189 L52.935552,40.7713514 L65.154672,53.0027027 L103.335912,14.7832432 C106.709832,11.4048649 106.709832,5.92918919 103.335912,2.55189189",
    id: "bg",
    fill: "#1AAD94"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatticeLogoNestColor);
export default __webpack_public_path__ + "static/media/lattice_logo_nest_color.cbb793f6.svg";
export { ForwardRef as ReactComponent };